export const enemies = [
  {
    sprite: "zombie",
    stats: {
      maxLife: 2,
      speed: 25,
      damage: 1,
    },
    wave: 0,
    xp: 20,
  },
  {
    sprite: "ghost",
    stats: {
      maxLife: 1,
      speed: 100,
      damage: 1,
    },
    wave: 8,
    xp: 10,
  },
  {
    sprite: "giga",
    stats: {
      maxLife: 5,
      speed: 12,
      damage: 3,
    },
    wave: 15,
    xp: 30,
  },
]